import { httpClient } from '@/network/clientController'

/** Create interbank recurring transfer for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_transfersinterbankrecurringcreate
*/
export const createInterbankRecurringTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'transfers/interbank/recurring/create',
		data: payload,
		operationTypeId: 21087 /* for mocks handling of tokens */
	})
}

/** Get Interbank Recurring Transfers List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersinterbankrecurring
*/
export const getInterbankRecurringTransfersList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'transfers/interbank/recurring',
        params: payload,
		isCancellable: true
	})
}

/** Edit recurring transfer for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_transfersinterbankrecurringedit%7BaccountId%7D%7BtransferId%7D
*/
export const editInterbankRecurringTransfer = (payload) => {
	return httpClient({
		method: 'PUT',
		url: `transfers/interbank/recurring/edit/${payload.accountId}/${payload.transferId}`,
		data: payload.data,
		operationTypeId: 21089 /* for mocks handling of tokens */
	})
}

/** Deletes interbank recurring transfer for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_transfersinterbankrecurring
*/
export const deleteInterbankRecurringTransfer = payload => {
	return httpClient({
		method: 'DELETE',
		url: `transfers/interbank/recurring/${payload.accountId}/${payload.transferId}`,
		operationTypeId: 21088 /* for mocks handling of tokens */
	})
}
